import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
  selector: 'app-verify-account',
  imports: [
    MatButtonModule,
    NgOtpInputModule,
  ],
  templateUrl: './verify-account.component.html',
  styleUrl: './verify-account.component.css'
})
export class VerifyAccountComponent {
  otpConfig = {
    length: 6,
    inputStyles: { 
      'margin': '0 0.15rem', 
      'width': '2.5rem',
      'height': '3.12rem',
      'background-color': 'var(--background-light)',
      'border': '1px solid var(--primary-font)',
      'border-radius': '0.5rem',
    }
  }
  @Output() backEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  onBackClick() {
    this.backEmitter.emit(false);
  }
}
